import api from './api';

export const state = {
  cached: [],
};

export const getters = {};

export const mutations = {
};

export const actions = {
  fetchUser() {
    return api.MockedResources.getMock(api.Enum.UsersPathEnum.GET_LOGGED_IN_USER).data;
  },
};
